import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { ApiServiceInterface, CrudComponent, CrudOptions, CrudTableComponentInterface, FormServiceInterface } from '@hutsix/ngxh6';
import { OrderInterface } from '../../../../../_generated/api_interfaces/api/order.interface';
import { OrderIdOrdersGetCollectionTimestamp, OrderIdOrdersGetItem } from '../../../../../_generated/api_interfaces';

@Component({
    selector: 'app-order-table',
    templateUrl: './orders-table.component.html',
    styleUrls: ['./orders-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class OrdersTableComponent implements CrudTableComponentInterface, OnInit {
    @Input() public response: ReturnType<OrderInterface['apiOrdersGetCollection']>;
    @Input() public crud: CrudComponent;
    @Input() public complete: boolean;
    // public opts: CrudOptions = {
    //     title: 'Orders',
    //     icon: 'fa-users',
    //     objectLabel: 'Order',
    //     formSlug: 'order',
    //     apiEndpoint: '/api/v1/orders',
    //     queryKey: 'order',
    //     apiClassName: 'App\\Entity\\Order',
    //     hideHeader: false,
    // };

    public isCompletedTabActive: boolean;

    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
    ) {}

    ngOnInit() {
        this.isCompletedTabActive = this.crud.queryExtras.status === undefined || this.crud.queryExtras.status === 'COMPLETE';
    }

    protected readonly OrderIdOrdersGetItem = OrderIdOrdersGetItem;
    protected readonly OrderIdOrdersGetCollectionTimestamp = OrderIdOrdersGetCollectionTimestamp;
    protected readonly PaymentMethodEnum = OrderIdOrdersGetItem.PaymentMethodEnum;
}
